module.exports = "/packs/coaching_renewal_popup-sp-d105b08e0385e5454a1bd163e34e0538.png";